/* eslint-disable react/no-array-index-key */
import React from 'react';

const DisplayMinutes = ({ minutes, goldenGoals }) => (
  <div>

    {minutes?.map((min, i) => (
      <React.Fragment key={`minutes-${i}-${min?.matchMinute}}`}>

        <span
          className={goldenGoals?.includes(min?.matchMinute) ? 'txt-g' : ''}
        >
          {`${min?.matchMinute}'`}
        </span>
        {(i !== minutes.length - 1) && (
          <span>{', '}</span>
        )}

      </React.Fragment>
    ))}
  </div>
);

export default DisplayMinutes;
